import React, { memo } from 'react';
import { useTranslation } from "react-i18next"; 
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead'; 
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';  
import Typography from '@mui/material/Typography';  
import "css/customDialog.css";

const TableSortingProductLiquid = memo(({ productLiquidLinesheet, setProductLiquidLinesheet }) => {
  const {t,i18n} = useTranslation(['listDataForms']);

  const handleAmountChange = (index, value) => {
    const newData = [...productLiquidLinesheet]; // Clonamos el array correctamente
    newData[index].amount = value;
    newData[index].isSelected = value > 0;

    setProductLiquidLinesheet(newData); // Guardamos el nuevo array
  };

  const handleSelectChange = (index) => {
    const newData = [...productLiquidLinesheet]; // Clonamos el array correctamente
    newData[index].isSelected = !newData[index].isSelected;

    setProductLiquidLinesheet(newData);
  };
  
  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer component={Paper} className="formdi-table-container" sx={{ minHeight: '100%' }}>
        <Table sx={{ minWidth: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
          <TableHead>
            <TableRow>

              <TableCell sx={{ width: '70%' }} align="left">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_PRODUCTLIQUID').toUpperCase()}
                </Typography>
              </TableCell> 

              <TableCell sx={{ width: '20%' }} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_AMOUNT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '10%' }} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_SELECT').toUpperCase()}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productLiquidLinesheet.map((item, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <Typography style={{color:"#4e73df", fontSize: 18}} >
                    {i18n.language==='es'?item.productliquid_namees:item.productliquid_nameen}
                  </Typography>
                </TableCell>   
                <TableCell align="center">
                  <TextField
                    type="number"
                    size="small"
                    value={item.amount || 0}
                    onChange={(e) => handleAmountChange(index, e.target.value)}
                    inputProps={{ min: 0 }}
                    sx={{ width: '100%' }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={item.isSelected || false}
                    onChange={() => handleSelectChange(index)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

  );
});
 
export default TableSortingProductLiquid;
